<script>
  import { cart } from '../models/cart.js'

  export let product
  export let label = 'Add to Cart'

  $: quantity = $cart.reduce(
    (a, p) => a + (p.id === product.id ? p.quantity : 0),
    0,
  )
  $: unavailable = !product.active || product.in_stock <= 0
</script>

<style type="text/less">
  .buy {
    width: 100%;
  }

  .add {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-xs);
    width: 100%;
    min-height: 3.25rem;
    font-size: 1.125rem;
    border-width: 2px;
    background: var(--col-gray-100);
    font-weight: 600;
  }

  .in-cart {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    margin: 0 0 var(--spacing-xs);
    font-weight: 700;
    color: var(--col-gray-10);

    .icon {
      width: 1.5rem;
      height: 1.5rem;
      color: var(--col-success-d);
    }
  }

  .change {
    display: flex;
    gap: var(--spacing-sm);

    .btn {
      flex: 1 1 0;
      margin: 0;
      min-height: 2.75rem;
      font-size: 1rem;
    }
  }
</style>

<div class="buy">
  {#if quantity > 0}
    <p class="in-cart" role="status">
      <svg class="icon"><use href="/icons.svg#check" /></svg>
      In your cart{quantity > 1 ? ` (${quantity})` : ''}
    </p>
    <div class="change">
      <button class="btn btn-outline" on:click={() => cart.add(product)}>
        Add another
      </button>
      <button class="btn btn-outline" on:click={() => cart.remove(product)}>
        Remove
      </button>
    </div>
  {:else}
    <button
      class="btn btn-outline add"
      disabled={unavailable}
      on:click={() => cart.add(product)}>
      <svg class="icon"><use href="/icons.svg#cart" /></svg>
      {unavailable ? 'Sold out' : label}
    </button>
  {/if}
</div>
